module.exports = __webpack_public_path__ + "img/A07-20070158-003-LR.7c645a23.jpg";